module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/camera 2-e9367604257d7fdb74b3e64b38d3ef2e.svg";